<template>
  <div>
    <go-collapse :title="msg1" :open="isMainOpen">
      <p>
        Le requérant doit contacter le-la surveillant-e du domaine public, en charge du secteur sur lequel il souhaite obtenir un permis temporaire d'occupation du domaine public.
        Lors de ce contact, il devra être en possession des informations suivantes :
      </p>
      <ul>
        <li>coordonnées complète (y compris adresse e-mail)</li>
        <li>numéro IDAFF (xxx'xxx), si les travaux sont mandatés par un gestionnaire de réseaux communal</li>
        <li>localisation des travaux</li>
      </ul>

      <p>
        <img src="../assets/plan.png"/>
        <a
          href="https://www.lausanne.ch/.binaryData/website/path/lausanne/prestations/mobilite-et-amenagements-publics/demande-permis-utilisation-temporaire-domaine-public/contentAutogenerated/autogeneratedContainer/col1/06/linkList/0/websitedownload/plan-des-secteurs-occupation-dp.2022-06-30-10-20-21.pdf"
          class="niceLink">Plan des secteurs et numéros de téléphone</a>
      </p>
      <p>
        Après ce contact obligatoire, le requérant recevra, par e-mail, un identifiant de demande unique. Ce code est indispensable pour effectuer la demande d'occupation temporaire du domaine public.
        <br/><br/>
        Vous trouverez de plus amples informations, comme par exemple les délais de demande,
        les tarifs ou encore les conditions d'usage du domaine public, sur le
        <a href="https://www.lausanne.ch/prestations/mobilite-et-amenagements-publics/demande-permis-utilisation-temporaire-domaine-public.html">
          site web de la Ville de Lausanne
        </a>
      </p>
      <br/><br/>
      <p>
        Si vous avez des questions, n'hésitez pas à nous contacter.<br/><br/>
        Nous répondons à vos appels du lundi au vendredi, de 08h00 à 11h30 et de 14h00 à 16h00.<br/><br/>
        <strong>Service de la mobilité et de l’aménagement des espaces publics</strong><br/>
        Surveillance du domaine public<br/><br/>
        Téléphones  <a href="tel:+41213155412">+41 21 315  5412</a> ou  <a href="tel:+41213155262">5262</a><br/>
        E-mail <a href="mailto:podp@lausanne.ch">podp@lausanne.ch</a><br/>
      </p>
    </go-collapse>
<!--
    <template v-if="isItDevEnv">
      <go-collapse :title="msg3" :open="isMainOpen">
        <go-select-podp-demande id="demandelist" v-on:newguid="guidChanged" v-model="popdDemande" ></go-select-podp-demande>
      </go-collapse>
    </template>
-->
  </div>
</template>

<script>
  import { DEV, getLog } from './config'
  import goCollapse from './ui/goCollapse'
  import goSelectPodpDemande from './goSelectPodpDemande.vue'
  import {isNullOrUndefined} from 'cgil-html-utils'

  const log = getLog('demandeSansGuid', 4, 1)

  export default {
    name: 'DemandeSansGuid',
    components: {
      goCollapse,
      goSelectPodpDemande
    },
    data: function () {
      return {
        msg1: '1) Sécurité des chantiers :',
        msg2: '2) Surveillance du domaine public :',
        msg3: ' POUR LES TESTS Uniquement...',
        isItDevEnv: DEV,
        isMainOpen: true,
        popdDemande: null
      }
    },
    methods: {
      guidChanged: function (val) {
        log.l('# IN  App guidChanged', val)
        if (!isNullOrUndefined(val.value)) {
          log.l('# IN  DemandeSansGuid guidChanged about to navigate to ', val.value)
          /*
          this.$router
          window.location = `/#/demande/${val.value}?timestamp=${(new Date()).getTime()}`
          */
          this.$router.push({
            name: 'goelandFormPodp',
            params: {guid: val.value}
          })
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/DemandeSansGuid.vue